import React from 'react';
import { useTranslation } from 'react-i18next';
import RoutePath from 'App/RoutePath';
import { useUserEntitlements } from 'hooks/useUserEntitlements';
import { useHistory } from 'react-router';
import { GetHelpNowButton } from './styles';

type HelpButtonProps = {
  handleHelpRequired?(): void;
};

export const HelpButton = ({ handleHelpRequired }: HelpButtonProps) => {
  const { t: translate } = useTranslation('chatbot');
  const { entitlements } = useUserEntitlements();
  const history = useHistory();

  const onClick = () => {
    if (handleHelpRequired) {
      handleHelpRequired();
    }

    history.push(
      entitlements.unmindHelp
        ? `${RoutePath.Help}#immediate-support?referrer=nova`
        : `${RoutePath.Help}?referrer=nova`,
    );
  };

  return (
    <GetHelpNowButton
      onClick={onClick}
      label={translate('voice.help_button.label')}
      ariaLabel={translate('voice.help_button.label')}
      loading={!entitlements}
      className="get-help-now-button"
      variant="tertiary"
      icon={{ icon: 'call', position: 'left' }}
    />
  );
};
